import { IconButton } from "../components/iconButton/iconButton";

export const makeIconButton =
  (icon, defaultTooltip) =>
  ({ showTooltip = true, onClick }) => (
    <IconButton
      icon={icon}
      tooltip={showTooltip ? defaultTooltip : null}
      onClick={onClick}
    />
  );
